export default __webpack_public_path__ + "static/media/twentyYard.70e59c3a.jpg";